module.exports = __webpack_public_path__ + "img/project-name.68cfc697.svg";